class SpeakerPanel {
    constructor(container, speakerElement = 'b-speaker', blockName = 'b-speaker-panel') {
        this.blockName = blockName;
        this.panel = container;
        this.speakerElement = speakerElement;
        this.blur = this.panel.querySelector(`.${this.blockName}__blur`);
        this.closeButton = this.panel.querySelector(`.${this.blockName}__close`);
        
        this.speakers = document.querySelectorAll(`.${this.speakerElement}`);
        this.isPanelOpen = false;

        this.init();
    }
    
    init() {
        this.bindEvents();
    }
    
    bindEvents() {
        // Закрытие по крестику и блюру
        this.closeButton.addEventListener('click', () => this.closeModal());
        this.blur.addEventListener('click', () => this.closeModal());
        
        // Закрытие по клику вне модального окна
        this.panel.addEventListener('mousedown', (e) => {
            const content = this.panel.querySelector(`.${this.blockName}__wrapper`);
            if (!content.contains(e.target)) {
                this.closeModal();
            }
        });
        
        // Открытие модалки по клику на спикера
        this.speakers.forEach(speaker => {
            speaker.addEventListener('click', (e) => this.handleSpeakerClick(e, speaker));
        });
    }
    
    handleSpeakerClick(e, speaker) {
        if (e.target.closest('button,a')) return;
        
        const id = speaker.dataset.id;
        this.openModal(id);
    }
    
    openModal(speakerId) {
        const panelContent = this.panel.querySelector(`.${this.blockName}__content`);
        
        this.showSpinner(panelContent);
        
        fetch(`/api/speaker/${speakerId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.text();
            })
            .then(data => {
                panelContent.innerHTML = data;
                panelContent.querySelectorAll('[data-expandable]').forEach(element => {
                    new ExpandableText(element);
                });
            })
            .catch(error => {
                this.showError(panelContent, 'Не удалось загрузить данные спикера');
                console.error('Ошибка загрузки данных спикера:', error);
            });
        
        
        this.panel.classList.add('open');
        this.blur.classList.add('open');
        document.body.classList.add('no-scroll');
        this.isPanelOpen = true;
    }
    
    closeModal() {
        this.panel.classList.remove('open');
        this.blur.classList.remove('open');
        document.body.classList.remove('no-scroll');
        this.isPanelOpen = false;
    }

    showSpinner(container) {
        container.innerHTML = `
            <div class="${this.blockName}__spinner">
                <div class="spinner"></div>
            </div>
        `;
    }

    showError(container, message) {
        container.innerHTML = `<p>${message}</p>`;
    }
}
